/* eslint-disable indent */
/* eslint-disable no-unused-vars */
/* eslint-disable quotes */
import React, { useState } from "react";
import Heading from "../../components/Heading";
import "./style.scss";
import ProcessedRequests from "./ProcessedRequests";
import RTORequestsList from "./RTORequestsList";
import StatusUpdates from "./StatusUpdates";
import { Tabs } from "antd";

const RTOShipments = () => {
  const [activeKey, setActiveKey] = useState("1");
  const [tabValue, setTabValue] = useState("pending-requests");
  
  const onChange = (key) => {
    setActiveKey(key);
    if (key === "1") {
      setTabValue("pending-requests");
    } else if (key === "2") {
      setTabValue("processed-requests");
    } else if (key === "3") {
      setTabValue("status-updates");
    }
  };

  return (
    <div className="p-1">
      <Heading title="Manage Orders" />
      <div className="global-card-tab-container">
        <Tabs
          defaultActiveKey="1"
          activeKey={activeKey}
          onChange={onChange}
          items={[
            {
              label: "RTO Pending Requests",
              key: "1",
              children: <RTORequestsList tabValue={tabValue} />,
            },
            {
              label: "RTO Processed Requests",
              key: "2",
              children: <ProcessedRequests tabValue={tabValue} />,
            },
            {
              label: "All Orders",
              key: "3",
              children: <StatusUpdates tabValue={tabValue} />,
            },
          ]}
        />
      </div>
    </div>
  );
};

export default RTOShipments; 
